import styled from 'styled-components'
import { colors, updatedMedia } from 'client/styles'
import { InputWrapper, LabelText } from '../InputLine/styles'

export const SubscriptionsBase = styled.form`
  background-color: ${colors.white};
  width: 100%;
  padding-block: 0 40px;
  padding-inline: 20px;

  ${props =>
    props.withTitles &&
    `
    padding-block: 20px;
    padding-inline: 20px;
    ${updatedMedia.tablet} {
      padding-block: 40px;
      padding-inline: 40px;
    }
  `};
  ${props => props.withTitles && `border-block-start: 1px solid ${colors.grey4};`};

  ${LabelText} {
    max-width: 100%;
    overflow: hidden;
  }
`

export const Row = styled.div`
  width: 100%;
`

export const Title = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${colors.grey1};
  font-weight: 700;
  font-size: 21px;
  text-align: center;
  line-height: 150%;

  margin-block-end: 12px;

  ${updatedMedia.tablet} {
    ${props => !props.modalVariation && `font-size: 28px;`};
  }
`

export const SubTitle = styled(Row)`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${colors.grey2};
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  line-height: 150%;

  margin-block-end: 20px;
`

export const SubscriptionBox = styled(Row)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ${updatedMedia.tablet} {
    flex-direction: row;
    justify-content: center;
  }
`
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${updatedMedia.tablet} {
    ${props => (props.modalVariation ? `margin-block-start: 20px;` : `margin-block-start: 0;`)};
    ${props => !props.modalVariation && `width: auto;`};
  }
`

export const InputSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  ${InputWrapper} {
    width: 100%;
  }

  ${updatedMedia.tablet} {
    ${props => !props.modalVariation && `width: 363px;`};
  }
`

export const WrapperInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-block-end: 15px;

  ${updatedMedia.tablet} {
    ${props =>
      props.modalVariation
        ? `margin-inline: 0; margin-block: 0;`
        : `margin-inline: 20px; margin-block: 0;`};
    ${props => !props.modalVariation && `width: auto;`};
  }
`
